import { Box, MenuItem } from "@mui/material";
import React from "react";
import CustomSelect from "../../../../../components/ui/Select";
import CustomTextField from "../../../../../components/ui/Textfield";
import PhotoEditor from "../../../../../components/PhotoEditor";
import { StepComponentProps } from "../../AddBookingV2";
import StepHeader from "../StepHeader";

const DeceasedInformation: React.FC<StepComponentProps> = ({
  bookingData,
  setBookingData,
  isEdit,
  onUpdate,
  submitting,
}) => {
  const handleChange = (field: string, value: unknown) => {
    setBookingData((prev) => ({ ...prev, [field]: value as string }));
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <StepHeader
          title="Deceased Information"
          isEdit={isEdit}
          onUpdate={onUpdate}
          submitting={submitting}
        />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
            gap: 3,
            mb: 3,
          }}
        >
          <PhotoEditor
            initialImage={bookingData.photo_url || null}
            onSave={async (imageData: string) => {
              const response = await fetch(imageData);
              const blob = await response.blob();
              const file = new File([blob], "deceased_image.jpg", {
                type: blob.type,
              });
              setBookingData((prev) => ({
                ...prev,
                photo_url: imageData,
                deceasedImageFile: file,
              }));
            }}
            title="Upload Deceased Image"
          />
          <Box />
          <Box />
        </Box>

        {/* Salutation, Name, Surname */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
            gap: 3,
            mb: 3,
          }}
        >
          <CustomSelect
            label="Salutation"
            value={bookingData.deceased_salutation || ""}
            onChange={(e) =>
              handleChange("deceased_salutation", e.target.value)
            }
          >
            <MenuItem value="Mr">Mr</MenuItem>
            <MenuItem value="Mrs">Mrs</MenuItem>
            <MenuItem value="Ms">Ms</MenuItem>
            <MenuItem value="Dr">Dr</MenuItem>
            <MenuItem value="Rev">Rev</MenuItem>
            <MenuItem value="Prof">Prof</MenuItem>
            <MenuItem value="Sir">Sir</MenuItem>
            <MenuItem value="Fr">Fr</MenuItem>
            <MenuItem value="Pastor">Pastor</MenuItem>
            <MenuItem value="Hon">Hon</MenuItem>
          </CustomSelect>
          <CustomTextField
            label="Deceased Name"
            value={bookingData.deceased_name || ""}
            onChange={(e) => handleChange("deceased_name", e.target.value)}
          />
          <CustomTextField
            label="Deceased Surname"
            value={bookingData.deceased_surname || ""}
            onChange={(e) => handleChange("deceased_surname", e.target.value)}
          />
        </Box>

        {/* Other Name, Nickname, Gender */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
            gap: 3,
            mb: 3,
          }}
        >
          <CustomTextField
            label="Other Name"
            value={bookingData.second_name || ""}
            onChange={(e) => handleChange("second_name", e.target.value)}
          />
          <CustomTextField
            label="Nickname"
            value={bookingData.deceased_nickname || ""}
            onChange={(e) => handleChange("deceased_nickname", e.target.value)}
          />
          <CustomSelect
            label="Gender"
            value={bookingData.gender || ""}
            onChange={(e) => handleChange("gender", e.target.value)}
          >
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
          </CustomSelect>
        </Box>

        {/* Type of Service, Religion, Denomination */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
            gap: 3,
            mb: 3,
          }}
        >
          <CustomSelect
            label="Type of Service"
            value={bookingData.type_of_service || ""}
            onChange={(e) => handleChange("type_of_service", e.target.value)}
          >
            <MenuItem value="Funeral">Funeral</MenuItem>
            <MenuItem value="Celebration">Celebration of life</MenuItem>
            <MenuItem value="Burial">Burial</MenuItem>
          </CustomSelect>
          <CustomSelect
            label="Religion"
            value={bookingData.religion || ""}
            onChange={(e) => handleChange("religion", e.target.value)}
          >
            <MenuItem value="christianity">Christianity</MenuItem>
            <MenuItem value="islam">Islam</MenuItem>
            <MenuItem value="hinduism">Hinduism</MenuItem>
            <MenuItem value="buddhism">Buddhism</MenuItem>
            <MenuItem value="judaism">Judaism</MenuItem>
            <MenuItem value="traditional_african">Traditional African</MenuItem>
            <MenuItem value="other">Other</MenuItem>
          </CustomSelect>
          <CustomTextField
            label="Denomination"
            value={bookingData.denomination || ""}
            onChange={(e) => handleChange("denomination", e.target.value)}
          />
        </Box>

        {/* Sunrise, Sunset */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
            gap: 3,
            mb: 5,
          }}
        >
          <CustomTextField
            label="Sunrise"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={bookingData.deceased_dob || ""}
            onChange={(e) => handleChange("deceased_dob", e.target.value)}
          />
          <CustomTextField
            label="Sunset"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={bookingData.deceased_dod || ""}
            onChange={(e) => handleChange("deceased_dod", e.target.value)}
          />
          <Box />
        </Box>
      </Box>
    </Box>
  );
};

export default DeceasedInformation;
